exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".Domain {\n  margin-top: 10px; }\n\n.flexRow {\n  display: flex;\n  justify-content: space-around;\n  width: 960px;\n  margin: 0 auto;\n  margin-top: 18px; }\n\n.flexElement {\n  width: 302px;\n  display: inline-block; }\n\n.flexElement:not(:first-child) {\n  margin-left: 5px; }\n", ""]);

// exports
